import styles from "../styles/especialidades.module.css";
import { FaUserMd, FaLungs, FaChild, FaDotCircle, FaHeartbeat, FaLeaf } from "react-icons/fa";

const especialidades = [

  
    {
        icono: <FaHeartbeat />,
        titulo: "Fisioterapia",
        descripcion: (
            <>
                <strong>Dolores</strong> de espalda, <strong>esguinces</strong>, <strong>fracturas</strong>, rehabilitación pre y <strong>postoperatorio</strong> de traumatología.
            </>
        ),
        imagen: "assets/fisioterapia-general.png"
    },
    {
        icono: <FaDotCircle />,
        titulo: "Readaptación",
        descripcion: (
            <>
                <strong>Herramientas terapéuticas</strong> para la <strong>corrección de factores de riesgo</strong> y prevenir procesos agudos y crónicos.
               
            </>
        ),
        imagen: "assets/hipopresivos.png"
    },
    {
        icono:  < FaChild />,
        titulo: "Entrenamientos",
        descripcion: (
            <>
                Ejercicios guiados por fisioterapeutas para <strong>mejorar la salud integral</strong> mediante movimientos controlados.
            </>
        ),
        imagen: "assets/cardiorrespiratoria.png"
    },
  /* 
  
    {
        icono: <FaLungs />,
        titulo: "Fisioterapia pediátrica",
        descripcion: (
            <>
                Evaluación y <strong>tratamiento del desarrollo de bebés, niños y adolescentes</strong> a nivel motor, respiratorio y digestivo.
            </>
        ),
        imagen: "assets/fisioterapia-pediatrica.png"
    },
  
    {
        icono: <FaUserMd />,
        titulo: "PsicoNeuro Inmunología(PNI)",
        descripcion: (
            <>
              Enfocados en la <strong>tonificación del suelo pélvico</strong> y <strong>músculos abdominales</strong>, con supervisión profesional.
            </>
        ),
        imagen: "assets/pni.png"
    },
    
    {
        icono: <FaLeaf />,
        titulo: "Pilates",
        descripcion: (
            <>
               Diagnóstico y <strong>tratamiento de afecciones respiratorias y musculares</strong> relacionadas con la región <strong>torácica</strong>.
             
            </>
        ),
        imagen: "assets/pilates.png"
    },  */
    
];

export default function Especialidades() {
    return (
        <section className={styles.especialidades}>
            <h2>ÁREAS DE ESPECIALIZACIÓN</h2>
            <p>Tratamientos personalizados en distintas ramas terapéuticas</p>
            <div className={styles.grid}>
                {especialidades.map((item, idx) => (
                    <div key={idx} className={styles.card}>
                        <div className={styles.cardContent}>
                            <div className={styles.icono}>{item.icono}</div>
                            <h3>{item.titulo}</h3>
                            <p>{item.descripcion}</p>
                        </div>
                        <div className={styles.cardImage}>
                            <img src={item.imagen} alt={item.titulo} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
